import { CloseButton, Flex, Icon, IconButton, Input, InputGroup } from "@chakra-ui/react"
import type { ChangeEvent, KeyboardEvent } from "react"
import { FaSearch } from "react-icons/fa"

interface SearchFieldProps {
  inputValue: string
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void
  onClick: () => void
  onClear: () => void
}


const SearchField = ({
  inputValue,
  onInputChange,
  onKeyDown,
  onClick,
  onClear,
}: SearchFieldProps) => {
  return (
    <Flex>
      <InputGroup
        endElement={
          inputValue &&
            <CloseButton
              size="xs"
              onClick={onClear}
              _hover={{
                backgroundColor: "transparent",
                color: "main",
              }}
            />
        }
      >
        <Input
          placeholder="Suche"
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          name="search"
          w="xs"
          borderRightRadius={0}
          outline="none"
        />
      </InputGroup>
      <IconButton
        aria-label="search-button"
        onClick={onClick}
        cursor="pointer"
        backgroundColor="main"
        borderRightRadius="md"
        borderLeftRadius={0}
        borderColor="main"
        color="white"
        _hover={{ bg: "transparent", color: "main" }}
      >
        <Icon as={FaSearch} color="inherit" boxSize="16px" />
      </IconButton>
    </Flex>
  )
}

export default SearchField
